import { useState } from "react";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { api, errorText } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export const ChangePasswordDialog = ({ open, onOpenChange, forced = false }) => {
  const { updateUser } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) { toast.error("New password and confirmation do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      updateUser({ must_change_password: false });
      toast.success("Password changed");
      setF({ current_password: "", new_password: "", confirm: "" });
      onOpenChange(false);
    } catch (err) { toast.error(errorText(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!forced || o) onOpenChange(o); }}>
      <DialogContent className="sm:max-w-md" data-testid="change-password-dialog" onInteractOutside={(e) => forced && e.preventDefault()} onEscapeKeyDown={(e) => forced && e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="font-heading inline-flex items-center gap-2"><KeyRound size={18} className="text-emerald-600" /> {forced ? "Set a new password" : "Change password"}</DialogTitle>
          <DialogDescription>{forced ? "You signed in with a temporary password. Choose your own password to continue (minimum 8 characters)." : "Enter your current password and choose a new one (minimum 8 characters)."}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>{forced ? "Temporary password" : "Current password"}</Label><PasswordInput value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} required data-testid="current-password-input" /></div>
          <div className="space-y-1.5"><Label>New password</Label><PasswordInput value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} required minLength={8} data-testid="new-password-input" /></div>
          <div className="space-y-1.5"><Label>Confirm new password</Label><PasswordInput value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required minLength={8} data-testid="confirm-password-input" /></div>
          <Button type="submit" disabled={busy} className="w-full bg-slate-900 hover:bg-emerald-700" data-testid="change-password-submit">{busy ? "Saving..." : "Save new password"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
